__turbopack_context__.v({
  "descriptionTextStyles": "plancard-module-scss-module__qp11XG__descriptionTextStyles",
  "headlineStyles": "plancard-module-scss-module__qp11XG__headlineStyles",
  "icon": "plancard-module-scss-module__qp11XG__icon",
  "iconWrapper": "plancard-module-scss-module__qp11XG__iconWrapper",
  "mainWrapper": "plancard-module-scss-module__qp11XG__mainWrapper",
  "textContentWrapper": "plancard-module-scss-module__qp11XG__textContentWrapper",
});
